import styled from "styled-components";

export const StyledClientsListWrapper = styled.div`
  .clients-head {
    padding: 20px 0 30px;
    display: grid;
    grid-template-columns: max-content 175px 1fr;
    grid-gap: 20px;

    &_superAdmin {
      grid-template-columns: max-content 175px 1fr;
    }

    &__create {
      display: inline-grid;
      justify-content: end;
    }

    @media screen and (max-width: 768px) {
      grid-template-columns: 100%;

      &__create {
        justify-content: start;
      }
    }
  }

  .client-table {
    &__head, &__row {
      grid-template-columns: minmax(max-content, 1fr) repeat(2, 1fr) minmax(200px, 1fr) repeat(2, 1fr);
    }
  }

  .admin-client-table {
    &__head, &__row {
      grid-template-columns: minmax(200px, 250px) repeat(2, minmax(180px, 200px)) minmax(180px, 200px) repeat(2, minmax(190px, 230px));
    }
  }
`;

export const StyledClientDescription = styled.div`
  transition: all .3s ease;
 
  p {
    text-align: left;
  }
`;

export const StyledClientsEditNickname = styled.div`
 .nickname-edit {
  display: grid;
  grid-template-columns: 210px;

  b {
   font-weight: 600;
  }

  &-form {
   display: grid;
   grid-template-columns: 210px;
   grid-gap: 5px;

   input {
    width: 100%;
   }

   &__actions {
    display: grid;
    grid-template-columns: repeat(2, max-content);
    grid-gap: 10px;
   }
  }
   
  .read-more {
   width: max-content;
   margin: 6px 0;
   padding: 3px 7px;
   border-radius: 25px;
   color: #fff;
   font-size: 12px;
   font-weight: 600;
   background-color: #277661;
   border: none;
   outline: none;
  }
 }
`;

export const StyledSupportUserCreate = styled.div`
  display: inline-grid;
  grid-template-rows: 55px;
  button {
    height: 100%;
  }
`;

export const StyledSupportUserCreateForm = styled.div`
  max-width: 270px;
  width: 100%;
  .generate-data {
    font-size: 14px;
    &:not(:last-child) {
      margin-bottom: 10px;
    }
    &__value {
      width: 100%;
      font-weight: 700;
      overflow-wrap: break-word;
    }
  }
`;

export const StyledRangeFeeInvoiceWrapper = styled.div`
  display: inline-grid;
  grid-template-rows: 55px;
  button {
    height: 100%;
  }
`;

export const StyledClientDetailsWrapper = styled.div`
  .tab-body {
    @media screen and (max-width: 992px) {
      padding: 0;
      border: none;
      border-radius: 0;
      box-shadow: none;
    }
    .content-head {
      padding: 20px 0;
      display: grid;
      grid-template-columns: max-content 175px;
      grid-gap: 20px;
      @media screen and (max-width: 768px) {
        grid-template-columns: 100%;
      }
    }
  }
  
  .client-details-head {
    margin-bottom: 20px;
  }
  .client-info {
    display: grid;
    grid-template-columns: minmax(min-content, max-content) 1fr;
    grid-gap: 50px;
    @media screen and (max-width: 992px) {
      grid-template-columns: 100%;
      grid-gap: 30px;
    }

    &__content {
     display: flex;
     flex-wrap: wrap;
     column-gap: 30px;
     row-gap: 16px;

     .client-info__description {
      flex-basis: 100%;
     }
    }
   
    &__row {
      display: grid;
      grid-template-columns: 20px 1fr;
      grid-gap: 20px;
      align-items: center;
      span {
        color: #162954;
        font-size: 20px;
      }
    }
    &__email p {
      max-width: 210px;
      width: 100%;
      overflow-wrap: break-word;
      cursor: pointer;
    }
  }

  .client {
    display: grid;
    grid-template-columns: 70px auto;
    grid-gap: 20px;
    align-items: center;
    &__name {
      color: #162954;
      font-size: 18px;
      font-weight: 600;
      display: flex;
      flex-wrap: wrap;
      gap: 5px;
      span {
        opacity: 0.25;
      }
    }
    &__image {
      width: 70px;
      height: 70px;
      color: #fff;
      font-size: 32px;
      font-weight: 600;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #29DEAE;
      border-radius: 50%;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }
    }
  }
  
  .transactions-table_scroll {
    @media screen and (max-width: 992px) {
      overflow: inherit;
    }
  }
  .transactions-table {
    &__head, &__row {
      grid-template-columns: repeat(2, minmax(250px, .85fr)) repeat(11, minmax(150px, 1fr)) repeat(2, minmax(150px, 1fr)) minmax(250px, .85fr) 220px;
    }
    .note {
      max-width: 200px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    @media screen and (max-width: 992px) {
      min-width: auto;
      overflow-x: inherit;
      &__head {
        display: none;
      }
      &__row {
        margin-bottom: 15px;
        grid-template-columns: repeat(2, 1fr);
        border: 1px solid #E5E5E5;
        & > div {
          padding-top: 20px;
          &:before {
            display: block;
          }
        }
      }
      &__note {
        max-width: 100%;
        white-space: inherit;
        overflow: inherit;
        grid-column-start: 1;
        grid-column-end: 3;
      }
      .icon-light-info {
        display: none;
      }
    }
    @media screen and (max-width: 599px) {
      &__row {
        padding: 15px 10px;
        grid-template-columns: 100%;
      }
      &__note {
        grid-column-end: 1;
      }
    }
  }
`;